
import { useNavigate } from 'react-router-dom';
import { Terrace } from '@/types/terrace';

interface MapPopupProps {
  terrace: Terrace;
}

export const createMapPopup = (terrace: Terrace, navigate: (path: string) => void) => {
  const getSunStatusDisplay = (status: string) => {
    switch (status) {
      case 'sunny':
        return "☀️ <span style='color:#FF8E53'>Sunny</span>";
      case 'soon':
        return "⏳ <span style='color:#FFB347'>Sun soon</span>";
      default:
        return "☁️ <span style='color:#5C3A28'>Not sunny</span>";
    }
  };

  const createPopupContent = () => {
    const popupDiv = document.createElement("div");
    popupDiv.className = "p-2 min-w-[160px] text-left";
    
    // Create elements safely to prevent XSS
    const nameDiv = document.createElement("div");
    nameDiv.className = "font-bold text-base mb-1";
    nameDiv.textContent = terrace.name; // Safe text assignment
    
    const statusDiv = document.createElement("div");
    statusDiv.className = "mb-2 flex items-center gap-2";
    
    const statusSpan = document.createElement("span");
    // Create status display without innerHTML to prevent XSS
    const statusIcon = document.createElement("span");
    const statusText = document.createElement("span");
    
    switch (terrace.sunStatus) {
      case 'sunny':
        statusIcon.textContent = "☀️ ";
        statusText.textContent = "Sunny";
        statusText.style.color = "#FF8E53";
        break;
      case 'soon':
        statusIcon.textContent = "⏳ ";
        statusText.textContent = "Sun soon";
        statusText.style.color = "#FFB347";
        break;
      default:
        statusIcon.textContent = "☁️ ";
        statusText.textContent = "Not sunny";
        statusText.style.color = "#5C3A28";
    }
    
    statusSpan.appendChild(statusIcon);
    statusSpan.appendChild(statusText);
    statusDiv.appendChild(statusSpan);
    
    const button = document.createElement("button");
    button.className = "mt-1 px-3 py-1 bg-peach-orange text-white rounded hover:bg-peach-orange/90 focus:outline-none text-sm font-medium w-full";
    button.textContent = "See details";
    button.addEventListener("click", () => navigate(`/terrace/${terrace.slug}`));
    
    popupDiv.appendChild(nameDiv);
    popupDiv.appendChild(statusDiv);
    popupDiv.appendChild(button);

    return popupDiv;
  };

  return { createPopupContent };
};
